
inits.push("Toast.init()");

window.Toast = {
	step: 24,
	init: function () {

		// dynamische zeiten setzen
		$('.dynToast').each(function(event) {
			var $this = $(this);
			var dynToast = $this.attr('data-dyn');
			// async false !!!
			$.ajax({
				type: 'POST',
				url: '/Handler/Toast',
				dataType: 'json',
				async : false,
				data: { data: { 'dyn': dynToast } }
			}).done(function (data) {
				$this.attr('data-start',data[0]);
				$this.attr('data-end',data[1]);
				var src = $this.attr('data-url') + '&von=' + data[0] + '&bis=' + data[1];
				$this.attr('src',src);
			});
		});

		$('.toast-outer').each(function (i) {
			var $this = $(this);
			if ($this.attr('data-init') === 'true') {
				// skip
				return;
			}
			$this.attr('data-init', 'true');
			//Toast.update($this.find('.pegel-dropdown')[0]);
			//$this.find('.pegel-dropdown').change(function (event) {
			//	Toast.update($this);
			//});
			$this.zrID = $this.find('.stationId').val();
			$this.param = $this.find('.toast-Parameter').val();
			$this.find('.stationId').on('propertychange change click keyup input paste', function (event) {
				if ($this.zrID !== $(this).val()) {
					$this.find('.toastStatus').removeClass('icon-ok').addClass('icon-attention');
				} else {
					$this.find('.toastStatus').removeClass('icon-attention').addClass('icon-ok');
				}
			});
			$this.find('.toast-Parameter').on('propertychange change click keyup input paste', function (event) {
				if ($this.param !== $(this).val()) {
					$this.find('.toastStatus').removeClass('icon-ok').addClass('icon-attention');
				} else {
					$this.find('.toastStatus').removeClass('icon-attention').addClass('icon-ok');
				}
			});


			$this.find('.toastUpdate').click(function (event) {
				Toast.getZrId($this, $this.find('.stationId').val(), $this.find('.toast-Parameter').val(), $this.find('.toast-Start').val(), $this.find('.toast-End').val());
			});
			$this.find('.datetime').datetimepicker({
				changeMonth: true,
				changeYear: true,
				dateFormat: 'dd.mm.yy',
				timeFormat: "HH:mm",
				onSelect: function (d, i) {
					if (d !== i.lastVal) {
						$(this).change();
					}
				}
			});

			if ($this.find('.toast-image').length > 0) {
				// controlls
				$this.image = $this.find('.toast-image img');
				$this.start = Toast.getDate($this.image.attr('data-start'));
				$this.end = Toast.getDate($this.image.attr('data-end'));
				// 50% des aktuellen Zeitrahmens

				Toast.calcStep($this);// ($this.end - $this.start) / 2 / 1000 / 60 / 60;



				$this.find('.icon-plus-circled').off("click").click(function (event) {
					Toast.zoomPan($this, Toast.step / 2, ($this.step / 2) * -1);
				});
				$this.find('.icon-minus-circled').off("click").click(function (event) {
					Toast.zoomPan($this, (Toast.step/2) * -1, $this.step/2);
				});
				$this.find('.icon-left-circle').off("click").click(function (event) {
					Toast.calcStep($this);
					Toast.pan($this, $this.step * -1, $this.step * -1);
				});
				$this.find('.icon-right-circle').off("click").click(function (event) {
					Toast.calcStep($this);
					Toast.pan($this, $this.step, $this.step);
				});
				$this.find('.icon-reload').click(function (event) {
					$this.start = Toast.getDate($this.image.attr('data-start'));
					$this.end = Toast.getDate($this.image.attr('data-end'));
					Toast.calcStep($this);
					Toast.setImage($this);

				});
				$this.image.bind('DOMMouseScroll mousewheel', function (event) {
					if (event.deltaY < 0 || event.originalEvent.detail < 0) {
						$this.find('.icon-minus-circled').click();
					} else {
						$this.find('.icon-plus-circled').click();
					}
					return false;
				});
			}
		});
	},

	calcStep: function ($this) {
		$this.step = ($this.end - $this.start) / 1000 / 60 / 60;
		//console.log("pan: ", $this.step);
		//if ($this.step < Toast.step) {
		//	$this.step = Toast.step;
		//}
	},

	//nur verschieben ohne zoom
	pan: function ($this, hStart, hEnd) {
		//Toast.calcStep($this);

		// console.log("pan: " + hStart + " > " + hEnd);
		var startTime = $this.start.getTime() + hStart * 60 * 60 * 1000;
		var endTime = $this.end.getTime() + hEnd * 60 * 60 * 1000;

		if (endTime > startTime) {
			$this.start.setTime($this.start.getTime() + (hStart * 60 * 60 * 1000) / 2); //pan haelfte der timeline
			$this.end.setTime($this.end.getTime() + (hEnd * 60 * 60 * 1000) / 2);

			Toast.setImage($this);
		}
	},

	//zoom
	zoomPan: function ($this, hStart, hEnd) {
		var startTime = $this.start.getTime() + hStart * 60 * 60 * 1000;
		var endTime = $this.end.getTime() + hEnd * 60 * 60 * 1000;
		// console.log("zoomPan: " + hStart + " > " + hEnd);
		//$this.step = ($this.end - $this.start) / 1000 / 60 / 60 / 2;

		//Toast.calcStep($this);

		//es gibt kein bild wenn die endzeit vor der startzeit liegt
		// oder gleich
		if (endTime > startTime) {
			$this.start.setTime($this.start.getTime() + hStart * 60 * 60 * 1000);
			$this.end.setTime($this.end.getTime() + hEnd * 60 * 60 * 1000);

			Toast.setImage($this);
		}
	},

	setImage: function ($this) {
		var src = $this.image[0].src;
		// http://topo:soft@www.geolo.net/?cmd=Image&zrid=EG9x3vNkraf7abxPq0_IXg&von=201305010000&bis=201306020000
		src = src.replace(/von=\d+/, "von=" + Toast.getDateSting($this.start));
		src = src.replace(/bis=\d+/, "bis=" + Toast.getDateSting($this.end));
		$this.image[0].src = src;

	},

	getDateSting: function (d) {
		var strDate = (d.getYear() + 1900) + ("0" + (d.getMonth() + 1)).slice(-2) + ("0" + d.getDate()).slice(-2) + ("0" + d.getHours()).slice(-2) + ("0" + d.getMinutes()).slice(-2)
		return strDate;
	},

	getDate: function (strDate) {
		var rx = new RegExp(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/);
		return new Date(strDate.replace(rx, '$1-$2-$3T$4:$5'));
	},

	update: function (item) {
		var $container = $(item).closest('.toast-outer');
		var $stationId = $(item).find('toastId').val();
		var stationType = $(item).attr('data-type');
		//var url = 'http://www.geolo.net/?cmd=Query&Parameter=Wasserstand&Ort=' + $stationId + '&DefArt=K&Herkunft=F';

		$container.find('.drp-toast-parameter')
		var $drpParameter = $container.find('.drp-toast-parameter');
		$drpParameter.prop('disabled', true);
		$drpParameter.html('');

		var $drpLoader = $container.find('.drpLoader');
		$drpLoader.html('<img src="/img/loader.gif" alt="lade..." />');

		$.ajax({
			type: 'POST',
			url: '/Handler/HvD/ParameterType',
			dataType: 'json',
			data: { data: { 'type': stationType, 'pid': $stationId } }
		}).done(function (data) {
			$drpLoader.html('');
			currentParam = $container.find('.toast-Parameter').val();
			for (var i = 0; i < data.length; i++) {
				var $sel = data[i].value === currentParam ? ' selected="selected" ' : '';
				$option = $('<option value="' + data[i].value + '"' + $sel + '>' + data[i].value + '</option>');
				$drpParameter.append($option);
			}

			if ($container.find('.toast-Parameter').val() === 'null' || $drpParameter.val() !== currentParam) {
				$container.find('.toast-Parameter').val($drpParameter[0].options[0].value)
			}

			$drpParameter.off('change').on('change', function (event) {
				$container.find('.toast-Parameter').val($(this).val());
				Toast.getZrId($container, $stationId, $container.find('.toast-Parameter').val(), $container.find('.toast-Start').val(), $container.find('.toast-End').val());
			});
			Toast.getZrId($container, $stationId, $container.find('.toast-Parameter').val());
			$drpParameter.prop('disabled', false);
		});
	},
	getZrId: function ($container, id, parameter, start, end) {
		var $drpLoader = $container.find('.drpLoader');
		$drpLoader.html('<img src="/img/loader.gif" alt="lade..." />');
		var $drpParameter = $container.find('.drp-toast-parameter');
		$container.find('.toastStatus').removeClass('icon-attention').addClass('icon-spin5');
		var url = '/Handler/Toast';

		//if (parameter) parameter = parameter.replace('ü', 'ue')
		//sklu
		//Abluss & Subort=HR_W

		//var url = 'http://hvlnxhws01:8050/?cmd=Query&Parameter='+ parameter +'&Ort='+ id +'&DefArt=K&Herkunft=F';
		// $xDoc = simplexml_load_string(file_get_contents(TOAST_URL. "?cmd=Query&Parameter=".$data['param']."&Ort=".$data['id']."&DefArt=K&Herkunft=F"));
		var url = 'https://hvlnxhws01:8050/?cmd=Query&Parameter=' + parameter + '&Ort=' + id + '&DefArt=K&Herkunft=F';
		// console.log(url);
		var $link = $container.find('.zrIdLink');
		$link.show();
		// console.log($container.find('.zrIdLink'));
		$link.attr('href', url);
		$container.find('.toastStatus').removeClass('icon-spin5').addClass('icon-attention');
		// console.log($container.find('.zrIdLink').attr('href'));
		// console.log($container.find('.zrIdLink').href);

		//$.ajax({
		//	url: url,
		//	method: 'GET',
		//	async: false,
		//	data: { 'parameter': parameter, 'Ort': id, 'DefArt': 'K', 'Herkunft': 'F' }
		//}).done(function (data) {
		//	console.debug(data);
		//	$drpLoader.html('');
		//	$drpParameter.prop('disabled', false);
		//	if (data === '') {
		//		alert("Keine ZRID für " + id + " " + parameter + " erhalten.");
		//		$container.find('.toastStatus').removeClass('icon-spin5').addClass('icon-attention');
		//		return;
		//	}
		//	$container.find('.toast-zrId').val(data);
		//	$container.zrID = data;
		//	$container.find('.toastStatus').removeClass('icon-spin5').addClass('icon-ok');
		//}).error(function (a, b, c) {
		//	console.log(a);
		//};
	}
};

$('.toast-outer').length;
